import styled, { css } from 'styled-components';
import ContainerFlex from '~/components/containerFlex';

export const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2e3958;
  margin-bottom: 4px;
`;

export const Subtitle = styled.span`
  font-size: 14px;
  color: #6c757d;
  display: block;
`;

export const TypeSwitcher = styled(ContainerFlex)`
  margin-top: 12px;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TypeButton = styled.button<{ active: boolean }>`
  border: 1px solid ${({ active }) => (active ? '#e4003a' : '#cfd6e5')};
  background: ${({ active }) => (active ? '#e4003a' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#2e3958')};
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: border 0.2s ease, background 0.2s ease;

  &:hover {
    border-color: #e4003a;
  }
`;

export const ActionBlock = styled.div`
  display: flex;
  align-items: center;
`;

export const UpdateButton = styled.button`
  background: #e4003a;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.2);
`;

export const Filters = styled(ContainerFlex)`
  gap: 16px;
  flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 150px;
  max-width: 350px;
  gap: 4px;
`;

export const FilterLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #2e3958;
`;

export const FilterSelect = styled.select`
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  padding: 8px 12px;
  min-width: 160px;
  background: #fff;
  color: #2e3958;
  font-size: 14px;
`;

export const InfoRow = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #6c757d;
`;

export const SummarySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 12px;
`;

export const ChartCard = styled.div`
  flex: 1;
  min-width: 280px;
  max-width: 360px;
  padding: 24px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
`;

export const ChartCaption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
`;

export const StatusText = styled.span`
  color: #6c757d;
`;

export const MetricGrid = styled.div`
  flex: 2;
  display: grid;
  margin-left: 8px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
`;

export const MetricCard = styled.div`
  padding: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StatusBadge = styled.span<{ color?: string }>`
  display: inline-flex;
  padding: 6px 14px;
  border-radius: 999px;
  ${({ color = '#6c757d' }) => css`
    background: ${color}1a;
    color: ${color};
  `}
  font-weight: 600;
  font-size: 12px;
`;

export const HistorySection = styled.section`
  margin-top: 28px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #2e3958;
  margin-bottom: 12px;
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.05);
`;

export const HistoryRow = styled.tr`
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #f8f9fd;
  }
`;

export const HistoryHeaderCell = styled.th`
  text-align: left;
  padding: 16px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  background: #f4f5fa;
`;

export const HistoryCell = styled.td`
  padding: 16px;
  border-top: 1px solid #f1f3ff;
  font-size: 14px;
  color: #2e3958;
  vertical-align: top;

  strong {
    display: block;
    font-size: 16px;
    margin-bottom: 4px;
  }

  span {
    font-size: 12px;
    color: #6c757d;
  }
`;

export const EmptyState = styled.div`
  margin-top: 16px;
  padding: 32px;
  text-align: center;
  color: #6c757d;
  background: #fff;
  border-radius: 12px;
  border: 1px dashed #dcdfe6;
`;

export const ErrorState = styled(EmptyState)`
  color: #b32d2d;
  border-color: #f8d7da;
`;

export const TemplateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
`;
